import type { ReadonlyRecord } from '../../../../utils'

import type { ParserError } from '../types'

type ErrorInformation = ReadonlyRecord<'dataPath' | 'content' | 'message', string | null>

const mapParserErrorContent = (error: ParserError): string | null => {
    if (typeof error.params === 'string') {
        return error.params || null
    }

    if (error.params && 'additionalProperty' in error.params) {
        return error.params.additionalProperty || null
    }

    if (error.params && 'allowedValues' in error.params) {
        return error.params.allowedValues?.join(', ') || null
    }

    return null
}

const mapParserErrorInformation = (error: ParserError): ErrorInformation => ({
    dataPath: error.dataPath || null,
    content: mapParserErrorContent(error),
    message: error.message || null,
})

export const mapParserErrorsInformation = (errors: readonly ParserError[]): Map<string | null, string> =>
    errors.reduce<Map<string | null, string>>((m, error) => {
        const { dataPath, message, content } = mapParserErrorInformation(error)
        const finalContent = [message, content].filter((m) => m).join(': ')
        return !finalContent && !dataPath ? m : m.set(dataPath, finalContent)
    }, new Map([]))
